<template>
  <b-container fluid class="px-0">
    <Nav :orderline_total="orderline_total" @emit-sidebar="toggleSidebar"></Nav>
    <div v-if="showoverlay" class="top-spinner">
      <b-spinner style="width: 3rem; height: 3rem;" label="Please wait..."></b-spinner>
    </div>
    <b-overlay class="overspin" :show="showoverlay" rounded="sm" fixed>
      <div class="section-header p-0 bg-light">
        <b-row v-if="enviro=='staging'">
          <b-col class="pl-5" style="background: yellow; color: black;">This is a test environment only. Orders will not be processed!</b-col>
        </b-row>

      <!-- TEMPORARY ADD FOR LILYS GUAC -->
        <b-row v-if="vendor_id==19" class="pt-2 addr-dets">
          <b-col style="background: yellow; color: black; text-align: center;">NEXT SAN JOSE DELIVERY WILL BE ON JAN 24th 2021. PLACE YOUR ORDERS NOW!</b-col>
        </b-row>
      <!-- END OF LILYS ADD -->

        <b-img id="bg-img" :src="vendor.hero_image_url" fluid alt="Good food"></b-img>
        <p class="pl-4 py-2 addr-dets">
           {{ vendor_mailing_address }} |
          <b>&#128337; </b>
          <span v-if="hours[0]"> {{ hours[0].open_time | toTwelveHours }} - {{ hours[0].close_time | toTwelveHours }}</span>
          <span v-else> Closed today. Please order ahead.</span>
          <br/>
          <b>&#128222; </b><a :href="'tel:'+vendor_landline">{{vendor_landline}}</a> | <b>&#128232; </b> <a :href="'mailto:'+vendor_email">{{vendor_email}}</a></p>
      </div>

      <b-container fluid="md" class="menu-items">
        <b-row cols="2">
          <b-col>
            <b-button v-b-toggle.wherewhen-collapse block variant="light">#1 WHERE</b-button>
          </b-col>
          <b-col>
            <b-button v-b-toggle.wherewhen-collapse block variant="light">#2 WHEN</b-button>
          </b-col>
        </b-row>
        <b-collapse id="wherewhen-collapse" visible>
          <b-row cols="2" class="py-3">
            <b-col>
              <PickupDelivery
                :key="selectedLocation.id"
                :selectedLocation="selectedLocation"
                :selectedMenuDate="selectedMenuDate"
                @emit-order-options="setOrderOptions"
                @emit-error="postErrorToLog"
              ></PickupDelivery>
            </b-col>
            <b-col>
              <ChooseWhen
                v-if="selectedLocation.id"
                :selectedLocation="selectedLocation"
                :selectedMenuDate="selectedMenuDate"
                :todaysHours="hours[0]"
                @emit-selected-datetime="setWhen"
                @switch-asap="switchASAP"
              ></ChooseWhen>
            </b-col>
          </b-row>
          <!-- <b-alert v-if="!pickupState && pickupTime && asap!=true" show variant="danger">Invalid Pickup Time. Please choose again.</b-alert> -->
          <!-- <b-alert v-if="!pickupState && pickupTime" show variant="danger">Invalid Pickup Time. Please choose again.</b-alert> -->
        </b-collapse>

        <div class="pt-3">
          <div class="row col- justify-content-center categorylist">
            <div id="catscroll" class="scroller pb-2">
              <div id="leftarrow">
                <!-- <font-awesome-icon class="arrow-icon" :icon="['far', 'hand-point-left']" /> -->
                <b-icon icon="caret-left-fill" class="arrow-icon"></b-icon>
              </div>
              <div id="rightarrow">
                <!-- <font-awesome-icon class="arrow-icon" :icon="['far', 'hand-point-right']" /> -->
                <b-icon icon="caret-right-fill" class="arrow-icon"></b-icon>
              </div>
              <ul class="hs full">
                <Category
                  v-for="category of categories"
                  :cat=cat
                  v-bind:category="category"
                  v-bind:key="category.id"
                  @catemit="changeCategory">
                </Category>
              </ul>
            </div>
          </div>
          <b-pagination v-if="totalitems>itemlimit" v-model="currentPage" :total-rows="totalitems" :per-page="itemlimit" align="center" @input="changePage()"></b-pagination>
          <div>
            <Item
              v-for="item of items"
              v-bind:item="item"
              v-bind:key="item.id"
              :displayImages="vendor.display_item_images"
              @optionsemit="loadOptionsModal">
            </Item>
            <b-pagination v-if="totalitems>itemlimit" v-model="currentPage" :total-rows="totalitems" :per-page="itemlimit" align="center" @input="changePage()"></b-pagination>
            <div id="checkout" class="checkout customcard pb-2">
              <b-button id="checkout-button" class="my-2 bottom-button" pill variant="light" v-b-toggle.sidebar-orderdets>Checkout  <b-badge variant="light">{{orderline_total | toCurrency}}</b-badge></b-button>
              <b-button id="subtotal-button" style="display: none;" class="my-2 bottom-button" pill variant="light" >Order Subtotal  <b-badge variant="light">{{orderline_total | toCurrency}}</b-badge></b-button>
            </div>
            <div v-if="vendor.custom_footer">
              <p style="font-size: small; color: black;" v-html="vendor.custom_footer"></p>
            </div>
            <p class="my-2 footer">© {{ vendor.name }} ⎥ Powered by <a href="https://payoo.app">PAYOo</a> &#128640;</p>
          </div>
        </div>

        <Options
          id="modopt"
          v-if="showoptionsmodal"
          :current_item="current_item"
          :option_select="option_select"
          :edititem="edititem"
          :line_notes="line_notes"
          @emit-remove-old-item="removeOldItem"
          @emit-close-options-modal="closeOptionsModal"
        ></Options>

        <div>
          <b-sidebar
            id="sidebar-orderdets"
            bg-variant="light"
            text-variant="dark"
            right
            shadow
            backdrop
          >
            <Sidebar
              v-if="location_id!=0"
              :orderlines="orderlines"
              :hours="hours"
              :vendor_id="vendor_id"
              :location_id="location_id"
              :orderline_total="orderline_total"
              :locations="locations"
              :selectedMenuDate="selectedMenuDate"
              :asap="asap"
              :pickupState="pickupState"
              :pickupTime="pickupTime"
              :orderoptions="orderoptions"
              @emit-adjust-line="adjustOrderLine"
              @emit-error="postErrorToLog"
              @emit-payment-succeeded="showPaySuccessModal"
            ></Sidebar>
          </b-sidebar>
        </div>
      </b-container>
    </b-overlay>

    <b-modal
      id="pay-success"
      title="PAYMENT SUCCESSFUL"
      header-bg-variant="dark"
      header-text-variant="light"
      body-bg-variant="light"
      body-text-variant="dark"
      footer-bg-variant="light"
      no-close-on-esc
      no-close-on-backdrop
      hide-header-close
      >
      <!-- <p v-if="selectedMenuDate==todaysDate" class="my-4">Congratulations, your order {{payment_intent.new_order_number}} has been placed successfully! It will be ready for pickup at {{ this.pickupTime | toTwelveHours }}. You will receive a SMS message shortly confirming your order. Please call {{ vendor_landline }} with any questions about your order.</p>
      <p v-else class="my-4">Congratulations, your order {{payment_intent.new_order_number}} has been placed successfully! It will be ready for pickup on {{ this.selectedMenuDate | toTextDate }} at {{ this.pickupTime | toTwelveHours }}. You will receive a SMS message shortly confirming your order. Please call {{ vendor_landline }} with any questions about your order.</p> -->
      <p class="my-4">{{ modalSuccessMessage }}</p>
      <template v-slot:modal-footer>
        <b-button variant="dark" @click="resetPage()">OK</b-button>
      </template>
    </b-modal>
  </b-container>
</template>

<script>
// @ is an alias to /src
import Nav from '@/components/Nav.vue'
import Category from '@/components/Category.vue'
import Item from '@/components/Item.vue'
import Sidebar from '@/components/Sidebar.vue'
import Options from '@/components/Options.vue'
import PickupDelivery from '@/components/PickupDelivery.vue'
import ChooseWhen from '@/components/ChooseWhen.vue'
import moment from 'moment-timezone'

export default {
  name: 'Menu',
  components: {
    Nav,
    Category,
    Item,
    Sidebar,
    Options,
    PickupDelivery,
    ChooseWhen,
  },
  data () {
    return {
      vendor_id: Number(process.env.VUE_APP_VENDOR_ID),
      // location_id: Number(process.env.VUE_APP_DEFAULT_LOCATION),
      location_id: 0,
      cat: 0,
      categories: [],
      productlists: [],
      selected_pl: 0,
      items: [],
      orderlines: [],
      locations: [],
      vendor: [],
      line_notes: '',
      visible: true,
      current_item: [],
      option_select: [],
      currentPage: 1,
      edititem: false,
      olditem: {},
      hours: [],
      itemlimit: 15,
      totalitems: 0,
      showoptionsmodal: false,
      centralTime: {},
      payment_intent: [],
      showoverlay: true,
      pickupTime: '',
      errors: [],
      selectedMenuDate: moment().format('YYYY-MM-DD'),
      useScheduledProductLists: false,
      orderToday: true,
      todaysDate: moment().format('YYYY-MM-DD'),
      modalSuccessMessage: '',

      orderoptions: {
        cust_addr: '',
        address_confirmed: false,
        ordertype: '2',
        table: 0,
        deldistance: 0
      },
      selectedLocation: [],
      asap: true,
      initialSelect: true,
      pickupState: false,
      ignoreProdLists: false,
    }
  },

  watch: {
    orderline_total: function() {
      // add, then remove checkout button shake class
      let chk = document.getElementById('checkout');
      chk.classList.add('checkshake');
      setTimeout(function () {
        chk.classList.remove('checkshake');
      }, 1000);
      // set the item count for each item
      if (this.cat!=0) {
        this.retrieveItems(this.cat);
      }
    },

    selectedMenuDate: function() {
      this.retrieveCategories();
    }

  },

  computed: {
    classActive: function() {
      if (this.selectedMenuDate==this.todaysDate) {
        return 'active';
      } else {
        return '';
      }
    },

    vendor_mailing_address: function() {
      if (Object.keys(this.vendor).length > 0) {
        const vma = this.vendor.vendor_addresses.filter(addr => addr.address_type_id==1);
        return vma[0].address;
      } else {
        return '';
      }
    },

    vendor_landline: function() {
      if (Object.keys(this.vendor).length > 0) {
        const ll = this.vendor.vendor_addresses.filter(addr => addr.address_type_id==6);
        // return ll[0].address;

        var cleaned = ('' + ll[0].address).replace(/\D/g, '')
          var match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/)
          if (match) {
            return '(' + match[1] + ') ' + match[2] + '-' + match[3]
          }
          return null


      } else {
        return '';
      }
    },

    vendor_email: function() {
      if (Object.keys(this.vendor).length > 0) {
        const email = this.vendor.vendor_addresses.filter(addr => addr.address_type_id==4);
        return email[0].address;
      } else {
        return '';
      }
    },

    enviro: function() {
      if (process.env.VUE_APP_BASE_URL.includes('stage')) {
        return 'staging';
      } else {
        return 'production';
      }
    },

    itempages: function() {
        return Math.ceil(this.totalitems / this.itemlimit);
    },

    orderline_total: function() {
      var ordersubtotal = 0;
      for (const orderline of this.orderlines) {
        var linetotal = 0;
        linetotal+=orderline.std_price;
        linetotal = orderline.gcCardNumber ? orderline.gcTopUpAmount : linetotal + orderline.gcTopUpAmount
        for (const option of orderline.options) {
          // find how many options been selected and multiple the price by that amount
          var optqty = option.choiceitems.length;
          linetotal+=(option.add_price*optqty);
          for (const choiceitem of option.choiceitems) {
            linetotal+=(choiceitem.add_price*1);
          }
        }
        linetotal*=orderline.qty;
        ordersubtotal+=linetotal;
      }
      return ordersubtotal;
    },

    newOrderNumber: function() {
      if (Object.keys(this.payment_intent).length>0) {
        return ('new_order_number' in this.payment_intent) ? this.payment_intent.new_order_number : this.payment_intent.order_number
      } else {
        return ''
      }
    },
  },

  methods: {
    switchASAP(asap) {
        this.asap=asap;
    },

    toggleSidebar() {
      this.$root.$emit('bv::toggle::collapse', 'sidebar-orderdets');
    },

    setWhen(date, time, asap, state) {
      this.asap = asap;
      this.selectedMenuDate = date;
      this.pickupTime = time ? time : this.pickupTime;
      this.pickupState = state;
    },

    setOrderOptions(orderoptions) {
      this.orderoptions = orderoptions;
    },

    collapseDoW() {
      var olb = document.getElementById("order-later-btn");
      if (olb.classList.contains("not-collapsed")) {
        this.$root.$emit('bv::toggle::collapse', 'daysofweek');
      }
    },

    async closeOptionsModal() {
      await this.retrieveOrderFromDB();
      this.showoptionsmodal=false;
    },

    removeOldItem() {
      this.edititem=false;
      this.adjustOrderLine(this.olditem, 'remove');
    },

    async showPaySuccessModal(payment_intent, pickup_time, order_type, delivery_time=0, cust_addr) {
      this.pickupTime = pickup_time;
      this.payment_intent = payment_intent;
      const timeofdelivery = moment('2001-01-01T'+pickup_time).add(delivery_time, 'm');
      // set modal success message dependent on order type and pickup date
      switch(String(order_type)) {
        case '1':
          this.modalSuccessMessage="Your order "+this.newOrderNumber+" has been placed successfully! It will be delivered to "+cust_addr+" by "+timeofdelivery.format('h:mma')+". You will receive a SMS message shortly confirming your order. Please call "+this.vendor_landline+" with any questions about your order.";
          break;
        case '2':
          this.modalSuccessMessage="Your order "+this.newOrderNumber+" has been placed successfully! It will be ready for pickup on "+this.$options.filters.toTextDate(this.selectedMenuDate)+" at "+this.$options.filters.toTwelveHours(pickup_time)+". You will receive a SMS message shortly confirming your order. Please call "+this.vendor_landline+" with any questions about your order.";
          break;
        case '4':
          this.modalSuccessMessage="Your order "+this.newOrderNumber+" has been placed successfully! It is expected to be ready at "+this.$options.filters.toTwelveHours(pickup_time)+". Our staff will bring it to you when it is prepared.";
          break;
        case '5':
          this.modalSuccessMessage="Your order "+this.newOrderNumber+" has been placed successfully! It will be ready for pickup on "+this.$options.filters.toTextDate(this.selectedMenuDate)+" at "+this.$options.filters.toTwelveHours(pickup_time)+". You will receive a SMS message shortly confirming your order. Please call "+this.vendor_landline+" with any questions about your order.";
      }
      this.$bvModal.show("pay-success");
    },

    changePage() {
      this.showoverlay = true;
      this.retrieveItems(this.cat);
    },

    changeCategory(category) {
      this.currentPage=1;
      this.retrieveItems(category);
    },

    // updateMenuDate(date) {
    //   this.selectedMenuDate = date;
    //   // console.log(this.selectedMenuDate);
    //   this.retrieveDailyData();
    // },

/*
*********************************************************************************************************
AXIOS METHODS
*********************************************************************************************************
*/
    // retrieveProductLists() {
    //   // default is active only
    //   this.$api.get('locations/'+this.location_id+'/productlists')
    //     .then(response => {
    //      // JSON responses are automatically parsed.
    //      this.productlists = response.data.productlists;
    //      // change to match the current day
    //      this.selected_pl = response.data.productlists[0].id;
    //      // this.retrieveCategories(response.data.productlists[0].id);
    //      this.retrieveDailyData();
    //     })
    //     .catch(e => {
    //      this.errors.push(e)
    //      console.log(this.errors)
    //     })
    // },

    retrieveDailyData() {
      // fetch hours
      this.retrieveHours();
      this.retrieveCategories();
    },

    retrieveCategories() {
      var dateext = (this.useScheduledProductLists==true && this.ignoreProdLists==false) ? '&date='+this.selectedMenuDate : '';
      this.$api.get('locations/'+this.location_id+'/categories?active=True'+dateext)
        .then(response => {
         // JSON responses are automatically parsed.
         this.categories = response.data.categories
         // Are there any categories / items for the selected day?
         if (this.categories.length > 0) {
           // if this.cat (current category) has not yet been set, set the category to the first available category found
           // or if this.cat (current selected category) does not exist in the retrieved set of categories
           if (this.cat < 1 || response.data.categories.find(c => c.id == this.cat) == undefined) {
             this.cat = response.data.categories[0].id;
           }
           // retrieve all items for the chosen category
           this.retrieveItems(this.cat);
         } else {
           // there are no valid categories for this day
           // check to see if it's today's date and that this.cat==0 (first time loading) - if so, change the day
           if (this.selectedMenuDate==this.todaysDate && this.cat==0) {
             this.ignoreProdLists=true
             this.retrieveCategories()
           }
           // set this.cat = -1 (will show "no items message")
           this.cat = -1;
           this.showoverlay = false;
         }
        })
        .catch(e => {
         this.errors.push(e)
         console.log(this.errors)
        })
    },

    retrieveItems(category) {
      this.cat=category;
      var dateext = (this.useScheduledProductLists==true && this.ignoreProdLists==false) ? '&date='+this.selectedMenuDate : '';
      this.$api.get('/categories/'+category+'/items?page='+this.currentPage+'&limit='+this.itemlimit+'&active=True&onlineonly=True'+dateext)
      .then(response => {
        // JSON responses are automatically parsed.
        // this.items = this.formatItems(response.data.items)
        this.items = response.data.items;
        this.orderlines.map(line => this.setItemCount(line));
        // this.items.sort((a,b) => a.sort_order - b.sort_order);
        this.showoverlay = false;
        this.totalitems = response.data.total_items;
      })
      .catch(e => {
        this.errors.push(e)
        console.log(this.errors)
      })
    },

    formatItem(item) {
      if (item.options.length > 0) {
        // sort the options by id so you always have a consistent result
        item.options.sort((a,b) => a.sort_order - b.sort_order);
        for (const option of item.options) {
          for (const optitem of option.optionitems) {
            if (optitem.name == null) {
              // update the optionitem name with the item name if it's using an item instead
              optitem.name = optitem.item[0].name;
            }
            // add new text field containing add_price and name (leave blank if no additional price)
            if (optitem.add_price > 0){
              optitem.name_price = optitem.name + ' - $' + String(optitem.add_price);
            } else {
              optitem.name_price = optitem.name;
            }
          }
        }
      }
      return item;

      // for (const item of items) {
      // }
      // return items;
    },

    async retrieveLocations() {
      // fetch locations
      return this.$api.get('vendor/'+this.vendor_id+'/locations')
      .then(response => {
         // JSON responses are automatically parsed.
         this.locations = response.data.locations;
         this.useScheduledProductLists = response.data.locations[0].use_list_schedules;
         this.location_id = response.data.locations[0].id;
         this.selectedLocation = response.data.locations[0];
         // set vendor
         this.vendor = response.data.locations[0].vendor;
         moment.tz.setDefault(response.data.locations[0].vendor.timezone)
         // Set favicon
         const favicon = document.getElementById("favicon");
         favicon.href = this.vendor.company_logo_url;
         // Set title
         document.title = this.vendor.name;
         if (this.useScheduledProductLists == true) {
           this.selectedMenuDate=this.todaysDate;
         }
      })
      .catch(e => {
       this.errors.push(e)
       console.log(this.errors)
      })
    },


    retrieveHours() {
      // set day of week in chicago
      // var today = moment().isoWeekday();
      // today -= 1;
      var selday = moment(this.selectedMenuDate).isoWeekday()-1;
      // fetch opening hours for today
      this.$api.get('/locations/'+this.location_id+'/openinghours?day='+String(selday))
      .then(response => {
       // JSON responses are automatically parsed.
       this.hours = response.data.hours
      })
      .catch(e => {
       this.errors.push(e)
       console.log(this.errors)
      })
    },

    postErrorToLog(error, severity, stage, orderdata) {
      var env = this.environmentDetection();
      var data = {
        "component": "Front End Menu",
        "environment": env,
        "data": orderdata,
        "error": error,
        "severity": severity,
        "stage": stage,
        "secret": 'scullionnativeapron'
      };
      this.$api.post('/vendor/'+this.vendor_id+'/errorlog', data)
      .then( function( response ){
        console.log('error logged: '+response);
      }.bind(this))
      .catch(e => {
         console.log(e)
      })
    },

/*
*********************************************************************************************************
END OF AXIOS METHODS
*********************************************************************************************************
*/

    hideScrollArrows() {
      let catscroll = document.getElementById('catscroll');
      var rightarr = document.getElementById('rightarrow');
      if (catscroll.scrollWidth > catscroll.clientWidth + catscroll.scrollLeft) {
        // Can scroll to the right, show right arrow
        rightarr.style.display = 'block';
      } else {
        // Can't scroll to the right - hide right arrow
        rightarr.style.display = 'none';
      }

      var leftarr = document.getElementById('leftarrow');
      if (catscroll.scrollLeft > 0) {
        // Can scroll to the left, show left arrow
        leftarr.style.display = 'block';
      } else {
        // Can't scroll to the left, hide left arrow
        leftarr.style.display = 'none';
      }
    },

    // open up the options selection modal
    async loadOptionsModal(item, edit=true) {
      this.edititem = edit;
      // this.current_item = item;
      if (this.edititem == false) {
        await this.retrieveItemOptions(item)
        this.option_select = [];
        this.line_notes = '';
        // set default options for the current item
        for (let i in this.current_item.options) {
            if (this.current_item.options[i].select_qty==1) {
              this.option_select.push(this.current_item.options[i].optionitems[0].id);
            } else {
              this.option_select.push(undefined);
            }
        }
      }
      this.showoptionsmodal = true;
    },

    async retrieveItemOptions(item) {
      const item_id = item.id ? item.id : item.item_id
      // default is active only
      const { data } = await this.$api.get('items/'+item_id);
      this.current_item=this.formatItem(data.item);
    },

    // make adjustment to the orderitem based on the type of button selected
    adjustOrderLine(orderline, adjusttype) {
      switch (adjusttype) {
        case 'remove':
          // reduce quantity by one unless qty is one, in which case, remove
          if (orderline.qty>1) {
            orderline.qty-=1;
            this.updateOrderInDB(orderline, orderline.qty);
          } else if (orderline.qty===1) {
            this.removeOrderLineFromDB(orderline);
          }
          break;
        case 'add':
          // Update this.line_notes and this.option_select with info from orderline
          this.line_notes = orderline.notes;
          this.option_select = orderline.option_select;
          this.current_item = orderline;
          this.loadOptionsModal(orderline, false);
          break;
        case 'edit':
          // Update this.line_notes and this.option_select with info from orderline
          this.line_notes = orderline.notes;
          this.option_select = orderline.option_select;
          // set this.edititem to true
          this.edititem = true;
          this.olditem = orderline;
          this.current_item = orderline;
          this.loadOptionsModal(orderline);
          break;
      }
    },



/*
*********************************************************************************************************
INDEXEDDB METHODS
*********************************************************************************************************
*/
    // create data store (on mount)
    createIndexedDB() {
      const request = window.indexedDB.open("basket_db", 3);// Create schema (new version)
      request.onupgradeneeded = event => {
          const db = event.target.result;
          // If object store exists, delete it
          if (db.objectStoreNames.length==1) {
            db.deleteObjectStore("order");
          }
          // then recreate it
          const orderStore = db.createObjectStore(
              "order",
              { keyPath: [ "item_id", "choicestring", "notes" ] }
          );
          // create a compound index for item_id and choicestring - ensures qty only updated for truly identical items
          // arrays not allowed as indexes - https://stackoverflow.com/questions/20899744/how-to-create-index-on-array-element-in-indexeddb
          orderStore.createIndex("ItemIndex", "item_id" );
      };
    },

    updateOrderInDB(item, newqty) {
      const request = window.indexedDB.open("basket_db");
      request.onsuccess = () => {
        const db = request.result;
        const transaction = db.transaction([ "order" ], "readwrite");
        const orderStore = transaction.objectStore("order");
        orderStore.put({
          item_id: item.item_id,
          name: item.name,
          std_price: Number(item.std_price),
          description: item.description,
          image_path: item.image_path,
          is_giftcard: item.is_giftcard,
          gcCardNumber: item.gcCardNumber,
          gcTopUpAmount: item.gcTopUpAmount,
          qty: newqty,
          notes: item.notes,
          options: item.options,
          choicearray: item.choicearray,
          choicestring: item.choicestring,
          option_select: item.option_select
        });
        transaction.oncomplete = () => {
            db.close();
        };
      };
    },

    retrieveOrderFromDB() {
      const request = window.indexedDB.open("basket_db");
      request.onsuccess = () => {
        const db = request.result;
        const transaction = db.transaction([ "order" ], "readwrite");
        const orderStore = transaction.objectStore("order");
        const getRequest = orderStore.getAll();
        getRequest.onsuccess = () => {
          this.orderlines = getRequest.result;
        };
      };
    },

    setItemCount(line) {
      var item = this.items.find(i=>i.id==line.item_id);
      if (item) {
        if ('qtycnt' in item) {
          item['qtycnt'] += line.qty;
        } else {
          item['qtycnt'] = line.qty;
        }
        return item;
      }
    },

    removeOrderLineFromDB(item) {
      const request = window.indexedDB.open("basket_db");
      request.onsuccess = () => {
        const db = request.result;
        const transaction = db.transaction([ "order" ], "readwrite");
        const orderStore = transaction.objectStore("order");
        // compound key must be specified when deleting
        orderStore.delete([item.item_id, item.choicestring, item.notes]);
        transaction.oncomplete = () => {
          db.close();
        };
      };
      this.retrieveOrderFromDB();
    },

    resetPage() {
      location.reload();
      return false;
    },

/*
*********************************************************************************************************
END OF INDEXEDDB METHODS
*********************************************************************************************************
*/

    /**
    * JavaScript Client Detection
    * (C) viazenetti GmbH (Christian Ludwig)
    */
    environmentDetection() {
      var window = window;
      var unknown = '-';

      // screen
      var screenSize = '';
      if (screen.width) {
          var width = (screen.width) ? screen.width : '';
          var height = (screen.height) ? screen.height : '';
          screenSize += '' + width + " x " + height;
      }

      // browser
      var nVer = navigator.appVersion;
      var nAgt = navigator.userAgent;
      var browser = navigator.appName;
      var version = '' + parseFloat(navigator.appVersion);
      var majorVersion = parseInt(navigator.appVersion, 10);
      var nameOffset, verOffset, ix;

      // Opera
      if ((verOffset = nAgt.indexOf('Opera')) != -1) {
          browser = 'Opera';
          version = nAgt.substring(verOffset + 6);
          if ((verOffset = nAgt.indexOf('Version')) != -1) {
              version = nAgt.substring(verOffset + 8);
          }
      }
      // Opera Next
      if ((verOffset = nAgt.indexOf('OPR')) != -1) {
          browser = 'Opera';
          version = nAgt.substring(verOffset + 4);
      }
      // Edge
      else if ((verOffset = nAgt.indexOf('Edge')) != -1) {
          browser = 'Microsoft Edge';
          version = nAgt.substring(verOffset + 5);
      }
      // MSIE
      else if ((verOffset = nAgt.indexOf('MSIE')) != -1) {
          browser = 'Microsoft Internet Explorer';
          version = nAgt.substring(verOffset + 5);
      }
      // Chrome
      else if ((verOffset = nAgt.indexOf('Chrome')) != -1) {
          browser = 'Chrome';
          version = nAgt.substring(verOffset + 7);
      }
      // Safari
      else if ((verOffset = nAgt.indexOf('Safari')) != -1) {
          browser = 'Safari';
          version = nAgt.substring(verOffset + 7);
          if ((verOffset = nAgt.indexOf('Version')) != -1) {
              version = nAgt.substring(verOffset + 8);
          }
      }
      // Firefox
      else if ((verOffset = nAgt.indexOf('Firefox')) != -1) {
          browser = 'Firefox';
          version = nAgt.substring(verOffset + 8);
      }
      // MSIE 11+
      else if (nAgt.indexOf('Trident/') != -1) {
          browser = 'Microsoft Internet Explorer';
          version = nAgt.substring(nAgt.indexOf('rv:') + 3);
      }
      // Other browsers
      else if ((nameOffset = nAgt.lastIndexOf(' ') + 1) < (verOffset = nAgt.lastIndexOf('/'))) {
          browser = nAgt.substring(nameOffset, verOffset);
          version = nAgt.substring(verOffset + 1);
          if (browser.toLowerCase() == browser.toUpperCase()) {
              browser = navigator.appName;
          }
      }
      // trim the version string
      if ((ix = version.indexOf(';')) != -1) version = version.substring(0, ix);
      if ((ix = version.indexOf(' ')) != -1) version = version.substring(0, ix);
      if ((ix = version.indexOf(')')) != -1) version = version.substring(0, ix);

      majorVersion = parseInt('' + version, 10);
      if (isNaN(majorVersion)) {
          version = '' + parseFloat(navigator.appVersion);
          majorVersion = parseInt(navigator.appVersion, 10);
      }

      // mobile version
      var mobile = /Mobile|mini|Fennec|Android|iP(ad|od|hone)/.test(nVer);

      // cookie
      var cookieEnabled = (navigator.cookieEnabled) ? true : false;

      if (typeof navigator.cookieEnabled == 'undefined' && !cookieEnabled) {
          document.cookie = 'testcookie';
          cookieEnabled = (document.cookie.indexOf('testcookie') != -1) ? true : false;
      }

      // system
      var os = unknown;
      var clientStrings = [
          {s:'Windows 10', r:/(Windows 10.0|Windows NT 10.0)/},
          {s:'Windows 8.1', r:/(Windows 8.1|Windows NT 6.3)/},
          {s:'Windows 8', r:/(Windows 8|Windows NT 6.2)/},
          {s:'Windows 7', r:/(Windows 7|Windows NT 6.1)/},
          {s:'Windows Vista', r:/Windows NT 6.0/},
          {s:'Windows Server 2003', r:/Windows NT 5.2/},
          {s:'Windows XP', r:/(Windows NT 5.1|Windows XP)/},
          {s:'Windows 2000', r:/(Windows NT 5.0|Windows 2000)/},
          {s:'Windows ME', r:/(Win 9x 4.90|Windows ME)/},
          {s:'Windows 98', r:/(Windows 98|Win98)/},
          {s:'Windows 95', r:/(Windows 95|Win95|Windows_95)/},
          {s:'Windows NT 4.0', r:/(Windows NT 4.0|WinNT4.0|WinNT|Windows NT)/},
          {s:'Windows CE', r:/Windows CE/},
          {s:'Windows 3.11', r:/Win16/},
          {s:'Android', r:/Android/},
          {s:'Open BSD', r:/OpenBSD/},
          {s:'Sun OS', r:/SunOS/},
          {s:'Chrome OS', r:/CrOS/},
          {s:'Linux', r:/(Linux|X11(?!.*CrOS))/},
          {s:'iOS', r:/(iPhone|iPad|iPod)/},
          {s:'Mac OS X', r:/Mac OS X/},
          {s:'Mac OS', r:/(MacPPC|MacIntel|Mac_PowerPC|Macintosh)/},
          {s:'QNX', r:/QNX/},
          {s:'UNIX', r:/UNIX/},
          {s:'BeOS', r:/BeOS/},
          {s:'OS/2', r:/OS\/2/},
          {s:'Search Bot', r:/(nuhk|Googlebot|Yammybot|Openbot|Slurp|MSNBot|Ask Jeeves\/Teoma|ia_archiver)/}
      ];
      for (var id in clientStrings) {
          var cs = clientStrings[id];
          if (cs.r.test(nAgt)) {
              os = cs.s;
              break;
          }
      }

      var osVersion = unknown;

      if (/Windows/.test(os)) {
          osVersion = /Windows (.*)/.exec(os)[1];
          os = 'Windows';
      }

      switch (os) {
          case 'Mac OS X':
              osVersion = /Mac OS X (10[._\d]+)/.exec(nAgt)[1];
              break;

          case 'Android':
              osVersion = /Android ([._\d]+)/.exec(nAgt)[1];
              break;

          case 'iOS':
              osVersion = /OS (\d+)_(\d+)_?(\d+)?/.exec(nVer);
              osVersion = osVersion[1] + '.' + osVersion[2] + '.' + (osVersion[3] | 0);
              break;
      }

      const jscd = {
          screen: screenSize,
          browser: browser,
          browserVersion: version,
          browserMajorVersion: majorVersion,
          mobile: mobile,
          os: os,
          osVersion: osVersion,
          cookies: cookieEnabled,
      };

      return(
          'OS: ' + jscd.os +' '+ jscd.osVersion + ' - ' +
          'Browser: ' + jscd.browser +' '+ jscd.browserMajorVersion +
            ' (' + jscd.browserVersion + ') - ' +
          'Mobile: ' + jscd.mobile + ' - ' +
          'Cookies: ' + jscd.cookies + ' - ' +
          'Screen Size: ' + jscd.screen + ' - ' +
          'Full User Agent: ' + navigator.userAgent
      );
    },

    async prepareMenuPage() {
      await this.retrieveLocations();
      this.retrieveDailyData();
      // retrieve ProductLists (if using)
      // if (this.useScheduledProductLists == true) {
      //   this.retrieveProductLists();
      // } else {
      //   // else retrieve all categories
      //   this.retrieveDailyData();
      // }
    }

  // end of methods
  },

  // Fetches posts when the component is created.
  created() {
    // create IndexedDB
    try {
      this.createIndexedDB();
    } catch (error) {
      this.postErrorToLog(error, 4, 'Unable to create IndexedDB', 'No order');
    }
    this.prepareMenuPage();
  },

  mounted() {
    this.retrieveOrderFromDB();
    try {
      document.getElementById('catscroll').addEventListener('scroll', this.hideScrollArrows);
    } catch (error) {
      console.error(error);
    }
  },

  beforeDestroy() {
    try {
      document.getElementById('catscroll').removeEventListener('scroll', this.hideScrollArrows);
    } catch (error) {
      console.error(error);
    }

  }

}
</script>

<style>
  @import '../styles/style.css';

</style>
